// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"9fed128f","852":"bdd1ee94"}[chunkId] + ".chunk.js";
};